import {RunQueryState} from 'insights/warehouse/AnalyticsWarehouseTypes';
import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';
import {AsyncStatus} from 'ui-library/hooks/useAsyncState';

const runWarehouseQueryGlobalState = makeUseGlobalClientState<RunQueryState>({
  status: AsyncStatus.NOT_FETCHED,
});

export default runWarehouseQueryGlobalState;
